import { render } from "./DashboardAgentesView.vue?vue&type=template&id=65b382a1"
const script = {}

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__